import { render, staticRenderFns } from "./AlgorithmOptimize.vue?vue&type=template&id=56892918&scoped=true"
import script from "./AlgorithmOptimize.vue?vue&type=script&lang=js"
export * from "./AlgorithmOptimize.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmOptimize.vue?vue&type=style&index=0&id=56892918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56892918",
  null
  
)

export default component.exports